import { render } from "./ShareCourse.vue?vue&type=template&id=1434f144&scoped=true"
import script from "./ShareCourse.vue?vue&type=script&lang=js"
export * from "./ShareCourse.vue?vue&type=script&lang=js"

import "./ShareCourse.vue?vue&type=style&index=0&id=1434f144&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1434f144"]])

export default __exports__